<script>
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Loader from '../components/Loader';
import PopularDealCard from '../components/PopularDealCard';

export default {
    components: {
        Navbar,
        Footer,
        Loader,
        PopularDealCard,
    },

    metaInfo: {
        title: 'Leaderboards',
    },

    data() {
        return {
            selectedLeaderboardIndex: 0,
            leaderboards: ['Bronze', 'Silver', 'Gold', 'Platinum', 'Diamond'],

            selectedPeriodIndex: 0,
            periods: [
                'Today',
                'This Week',
                'This Month',
                'This Year',
                'All Time',
			],
			// Label on the filter in UI doesn't match the DB value:
			periodLabels: [
                '24 Hours',
                'Week',
                'Month',
                'Year',
                'All Time',
            ],
			tableColumns: [
                {
					name: '#',
					dbName: 'rank',
					asc: true,
				},
				{
					name: 'User',
					dbName: 'rank',
					asc: true,
				},
                {
					name: 'Stars',
					dbName: 'points',
					asc: false,
				},
				{
					name: 'Status',
					dbName: 'points',
					asc: false,
				},
                {
					name: '# Posts',
					dbName: 'post_count',
					asc: false,
				},

            ],
			currentSortIndex: 2,
            ranks: [],
            ranksAreLoading: false,
            retailersAreLoading: false,
			retailers: [],
			usernameSearch: [],
            myRank: {},
            isMore: true,
            page: 1,
            timeout: null,
        };
    },

	watch: {
		usernameSearch(searchTerm) {
            if (this.timeout) clearTimeout(this.timeout);

            this.timeout = setTimeout(() => {
			    this.setSearchTerm(searchTerm);
                this.getRanks();
            }, 500)
		},
	},


    async mounted() {
        await Promise.all([
            this.getRanks(),
            this.getRetailers(),
            this.getPopularDeals(),
            this.getMyRank(),
        ]);
	},


    methods: {
		async sort(index) {
			if (this.currentSortIndex === index) {
				this.tableColumns[index].asc = !this.tableColumns[index].asc;
			}
			this.currentSortIndex = index;
            this.page = 1;
            this.isMore = true;
            this.ranks = [];
			await this.getRanks();
		},


		async setBoardIndex(index) {
            this.selectedLeaderboardIndex = index;
            this.page = 1;
            this.isMore = true;
            this.ranks = [];
			await this.getRanks();
            await this.getMyRank();
		},


		async setPeriodIndex(index) {
            this.selectedPeriodIndex = index;
            this.page = 1;
            this.isMore = true;
            this.ranks = [];
			await this.getRanks();
            await this.getMyRank();
		},

        filterByUser(user) {
            this.$router.push('/?search=' + user);
        },


        async getRanks() {
            this.ranksAreLoading = true;
            const response = await window.axios.get('/api/leaderboards/', {
                params: {
                    leaderboard: this.leaderboards[this.selectedLeaderboardIndex],
					period: this.periods[this.selectedPeriodIndex],
					limit: 20,
					sortColumn: this.tableColumns[this.currentSortIndex].dbName,
					orderBy: this.tableColumns[this.currentSortIndex].asc ? 'asc' : 'desc',
					search: this.search,
                    page: this.page,
                },
            });
            this.ranks = this.ranks.concat(response.data.data);

            if (response.data.data.length === 0) {
                this.isMore = false;
            }

            this.page += 1;
            this.ranksAreLoading = false;
        },

        async getMyRank() {
            const response = await window.axios.get('/api/leaderboards/', {
                params: {
                    leaderboard: this.leaderboards[this.selectedLeaderboardIndex],
                    period: this.periods[this.selectedPeriodIndex],
                    me: true,
                },
			});
            this.myRank = response.data.data;
        },


        async getRetailers() {
            this.retailers = [];
            this.retailersAreLoading = true;
            const response = await window.axios.get('/api/retailers/');
            this.retailers = response.data.data;
            this.retailersAreLoading = false;
        },


        async getPopularDeals() {
            await this.$store.dispatch('getDeals', true); // Tell deals module we want the top 5 for 'Popular deals'
		},


		setSearchTerm(searchTerm) {
            this.page = 1;
			this.search = null; // Tell BE we don't have a search term
            this.ranks = [];
			if (searchTerm.length > 0) {
				this.search = [];
				this.search.push(`%${searchTerm}%`);
			}
        },

        getTooltipText(row) {
            const levelText = {
                1: 'Bronze',
                2: 'Silver',
                3: 'Gold',
                4: 'Platinum',
                5: 'Diamond',
            };

            let privileges = row.is_moderator ? 'Moderator' : 'Regular';
            privileges = row.is_admin ? 'Administrator' : privileges;

            return `This user has ${privileges} account privileges and has a current status of ${levelText[row.profilestatus]}`;
        },

        getLeaderboardIcon(status) {
            status = status.toLowerCase();
            return `images/assets/star-${status}.png`;
        },
    },

};
</script>
<template lang="pug" src="./templates/Leaderboards.pug"></template>
<style lang="stylus" src="./styles/Leaderboards.styl" scoped></style>
